var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPersonIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.25 11.5455C7.45507 11.5455 6 10.0802 6 8.27273C6 6.46525 7.45507 5 9.25 5C11.0449 5 12.5 6.46525 12.5 8.27273C12.5 10.0802 11.0449 11.5455 9.25 11.5455Z",
    fill: "#ADB5BD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.00054 19.2993C2.32355 15.1232 5.55159 13 9.48612 13C13.476 13 16.7541 15.0065 16.9983 19.3C17.008 19.471 16.9983 20 16.3722 20C13.2843 20 8.6956 20 2.60625 20C2.39726 20 1.98295 19.5268 2.00054 19.2993Z",
    fill: "#6C757D"
  })));
}

export default SvgPersonIcon;